import { Component, Input } from "@angular/core";
import { OrderFile } from "../../models/order.model";
import { CommonModule } from "@angular/common";

@Component({
  selector: "file-icon",
  templateUrl: "./file-icon.component.html",
  styleUrls: ["./file-icon.component.scss"],
  standalone: true,
  imports: [CommonModule],
})
export class FileIconComponent {
  @Input() file: OrderFile;
}
